import React from 'react';
import { ButtonPrimary, IconSpotifyLogo } from '@spotify-internal/encore-web';
import { useT } from 'i18n/hooks/useT';

type SpotifyConnectButtonProps = {
  onConnectSpotify: () => void;
};

export const SpotifyConnectButton = ({
  onConnectSpotify,
}: SpotifyConnectButtonProps) => {
  const t = useT();

  return (
    <ButtonPrimary
      colorSet="invertedDark"
      iconLeading={IconSpotifyLogo}
      onClick={onConnectSpotify}
    >
      {t(
        'SpotifyConnectButton.ConnectButtonLabel',
        'Connect Spotify',
        'Connect to Spotify button'
      )}
    </ButtonPrimary>
  );
};
